import { Address } from "@raskrask-dk/raskrask-utils";
import {Action} from "../../../action/action";
import type {AddressState} from "../addressState";

export class Next extends Action<"NEXT_STATE", Address> {
  readonly type = "NEXT_STATE";

  constructor(state: AddressState, data?: Address) {
    super(state, data);
  }

  public isValid(): boolean {
    const addr = this.data;
    const hasAddr = this.allHasValues(addr);
    return hasAddr && this.isDoable();
  }

  /**
   *
   * @returns boolean according to if the action currently is doable
   */
  public isDoable(): boolean {
    return true;
  }
}
